import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import LoadingIndicator from '../LoadingIndicator';

export default () => (
  <>
    <Heading level={1}>Large Loading Indicator</Heading>
    <Spacer size={16} />
    <Text>
      Displays a large <Code>{'LoadingIndicator'}</Code> with the user's
      competency color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <LoadingIndicator size="large" />
        <Spacer size={20} />
        <Code>{'size="large"'}</Code>
      </FlexView>
    </FlexView>
  </>
);
